import { registrarEvento } from "../core/auditLog.js";
import { deleteData, establecerNumeroDoc, fechaCierreVigente, saveData } from "../core/cloudSync.js";
import { genId } from "../core/utils.js";
import { navigateTo } from "../ui/app.js";

import { cargarConsecutivosActuales, getParametrosFiscales } from "../core/cloudSync.js";
import { C, DEFAULT_PARAMETROS_FISCALES, EMPRESA, PREFIJOS_CONSECUTIVOS } from "../core/config.js";
import { state } from "../core/state.js";
import { addDias, btnStyle, escapeHTML, fmtCOP, fmtDate, inputStyle, parseNumber } from "../core/utils.js";
import { render } from "../ui/app.js";
import { calcularDiasRestantes } from "./reportes.js";

export function renderParametrosFiscales() {
  const pf = getParametrosFiscales();

  const campo = (key, label, opts={}) => {
    const isPct = !!opts.pct;
    const value = pf[key] != null ? String(pf[key]) : "";
    return `
      <div>
        <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${label}</label>
        <div style="position:relative;">
          <input type="number" inputmode="decimal" step="${opts.step||"0.01"}" min="0"
            value="${escapeHTML(value)}"
            oninput="
              const pf=getParametrosFiscales();
              pf['${key}']=parseFloat(this.value)||0;
              saveParametrosFiscales(pf);
            "
            onchange="
              const pf=getParametrosFiscales();
              pf['${key}']=parseFloat(this.value)||0;
              saveParametrosFiscales(pf);
              render();
            "
            style="${inputStyle}${isPct?"padding-right:26px;":""}text-align:right;"/>
          ${isPct?`<span style="position:absolute;right:10px;top:50%;transform:translateY(-50%);font-size:11.5px;color:${C.muted};">%</span>`:""}
        </div>
        ${opts.help?`<div style="font-size:10px;color:${C.muted};margin-top:3px;">${opts.help}</div>`:""}
      </div>`;
  };

  const campoTexto = (key, label, help, placeholder) => `
    <div>
      <label style="font-size:10.5px;color:${C.muted};font-weight:600;display:block;margin-bottom:4px;">${label}</label>
      <input value="${escapeHTML(pf[key] != null ? String(pf[key]) : "")}" placeholder="${placeholder||""}"
        onchange="
          const pf=getParametrosFiscales();
          pf['${key}']=this.value;
          saveParametrosFiscales(pf);
          render();
        "
        style="${inputStyle}"/>
      ${help?`<div style="font-size:10px;color:${C.muted};margin-top:3px;">${help}</div>`:""}
    </div>`;

  const toggle = (key, label, help) => `
    <label style="display:flex;align-items:flex-start;gap:8px;font-size:11.5px;color:${C.text};cursor:pointer;background:#f8fafc;border:1px solid ${C.border};border-radius:6px;padding:6px 10px;">
      <input type="checkbox" ${pf[key]?"checked":""}
        onchange="
          const pf=getParametrosFiscales();
          pf['${key}']=this.checked;
          saveParametrosFiscales(pf);
          render();
        "
        style="margin-top:2px;"/>
      <span>
        <strong>${label}</strong>
        ${help?`<div style="font-size:10px;color:${C.muted};margin-top:2px;">${help}</div>`:""}
      </span>
    </label>`;

  const header = `
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:9px;padding-bottom:10px;border-bottom:3px solid ${C.gold};">
      <div style="display:flex;gap:10px;align-items:center;">
        <img src="${window.LOGO}" alt="Aura" style="height:42px;object-fit:contain;"/>
        <div>
          <h2 style="margin:0;font-size:16px;color:${C.text};font-weight:700;">📐 Parámetros Fiscales (Colombia)</h2>
          <p style="margin:3px 0 0;color:${C.muted};font-size:11.5px;">UVT, tarifas y reglas de retención — actualízalos aquí cuando cambie la normatividad. Se aplican de inmediato en la causación de facturas de proveedor.</p>
        </div>
      </div>
    </div>
  `;

  const aviso = `
    <div style="background:#fffbeb;border:1px solid #fde68a;border-radius:6px;padding:12px 16px;margin-bottom:10px;font-size:11.5px;color:#92400e;">
      ⚠️ <strong>Importante:</strong> el Gobierno Nacional/DIAN puede modificar estos valores cada año (especialmente la UVT, vigente desde el 1 de enero). Revisa y actualiza esta pantalla apenas se publique la resolución correspondiente — no requiere ningún cambio de código.
    </div>
  `;

  const seccionUVT = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">💲 Valores base</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;">
        ${campo("anio_vigencia","Año de vigencia",{step:"1"})}
        ${campo("uvt","Valor UVT (COP)",{step:"1",help:"Resolución DIAN — se publica cada diciembre/enero."})}
        ${campo("iva_general_pct","Tarifa general de IVA",{pct:true,help:"Art. 468 E.T."})}
        ${campo("renta_pct","Tarifa impuesto de renta",{pct:true,help:"Art. 240 E.T. — usada para la provisión estimada en el Estado de Resultados."})}
      </div>
    </div>
  `;

  // ── Aviso de bases desactualizadas ──────────────────────────────────────
  // Las cuantías mínimas del Decreto 572 de 2025 volvieron a regir el 1 de
  // julio de 2026 (Consejo de Estado, Auto del 2 de junio de 2026, exp. 30229):
  // compras 10 UVT y servicios 2 UVT, contra las 27 y 4 anteriores. Con las
  // bases viejas el ERP DEJA DE RETENER en el tramo intermedio, y la retención
  // no practicada la responde el agente retenedor (Art. 370 E.T.). No se corrige
  // solo: es un dato fiscal y lo confirma la contadora.
  const BASES_VIGENTES = { compras: 10, servicios: 2 };
  const baseC = parseNumber(pf.retefuente_compras_base_uvt) || 0;
  const baseS = parseNumber(pf.retefuente_servicios_base_uvt) || 0;
  const uvtHoy = parseNumber(pf.uvt) || 0;
  const desfasadas = baseC > BASES_VIGENTES.compras || baseS > BASES_VIGENTES.servicios;
  const avisoBases = !desfasadas ? "" : `
    <div style="background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;padding:12px 16px;margin-bottom:10px;font-size:11.5px;color:#991b1b;line-height:1.6;">
      <div style="font-weight:800;margin-bottom:5px;">⚠️ Las bases mínimas de retención están por encima de las vigentes</div>
      Desde el <b>1 de julio de 2026</b> rigen las cuantías del <b>Decreto 572 de 2025</b>, revivido por el Consejo de
      Estado (Auto del 2 de junio de 2026, exp. 30229): <b>compras 10 UVT</b> (${fmtCOP(10 * uvtHoy)}) y
      <b>servicios 2 UVT</b> (${fmtCOP(2 * uvtHoy)}).
      ${baseC > BASES_VIGENTES.compras ? `<div style="margin-top:5px;">· Compras: configurado ${baseC} UVT (${fmtCOP(baseC * uvtHoy)}) → <b>no se retiene</b> entre ${fmtCOP(10 * uvtHoy)} y ${fmtCOP(baseC * uvtHoy)}.</div>` : ""}
      ${baseS > BASES_VIGENTES.servicios ? `<div>· Servicios: configurado ${baseS} UVT (${fmtCOP(baseS * uvtHoy)}) → <b>no se retiene</b> entre ${fmtCOP(2 * uvtHoy)} y ${fmtCOP(baseS * uvtHoy)}.</div>` : ""}
      <div style="margin-top:6px;">La retención que no se practica la responde la empresa (Art. 370 E.T.). Confirma con tu
      contadora y corrige los dos campos de abajo — <b>solo aplica de aquí en adelante</b>, los documentos ya causados no se recalculan.</div>
    </div>`;

  const seccionRetefuente = `
    ${avisoBases}
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">📉 ReteFuente — bases y tarifas de referencia</h3>
      <div style="font-size:10.5px;color:${C.muted};margin-bottom:12px;">El % efectivo que se aplica por causación sigue siendo el configurado en cada tercero (Maestros → Proveedor). Aquí solo se define la <strong>base mínima en UVT</strong> y las tarifas sugeridas de referencia.</div>
      <div style="display:grid;grid-template-columns:1fr 1fr 1fr 1fr;gap:10px;">
        ${campo("retefuente_compras_pct","% Compras generales (ref.)",{pct:true})}
        ${campo("retefuente_compras_base_uvt","Base mínima compras (UVT)",{step:"1",help:"Art. 401 E.T. — 10 UVT desde el 1-jul-2026 (Dcto. 572 de 2025)"})}
        ${campo("retefuente_servicios_pct","% Servicios generales (ref.)",{pct:true})}
        ${campo("retefuente_servicios_base_uvt","Base mínima servicios (UVT)",{step:"1",help:"Art. 392 E.T. — 2 UVT desde el 1-jul-2026 (Dcto. 572 de 2025)"})}
      </div>
    </div>
  `;

  const seccionReteIVA = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">📦 ReteIVA</h3>
      <div style="display:grid;grid-template-columns:1fr;gap:10px;max-width:280px;">
        ${campo("reteiva_pct","% sugerido sobre el IVA generado",{pct:true,help:"Art. 437-1 E.T. — el % real se toma del tercero."})}
      </div>
    </div>
  `;

  // ICA de la PROPIA empresa: la tarifa la fija el municipio según la actividad
  // (la certifica el RIT). Antes vivía solo en memoria de la pantalla de
  // Contabilidad, con 4,14 ‰ de arranque: al recargar se perdía lo ajustado.
  const seccionICA = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 4px;font-size:14px;font-weight:700;color:${C.text};">🏙️ ICA de la empresa</h3>
      <div style="font-size:10.5px;color:${C.muted};margin-bottom:12px;">
        Municipio donde se declara industria y comercio y la tarifa de la actividad, <strong>en por mil (‰)</strong>.
        La certifica el <strong>RIT</strong> del municipio (en Bogotá, la Secretaría Distrital de Hacienda).
        Se usa para provisionar el ICA en Contabilidad y como sugerencia del ReteICA al facturar.
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;max-width:520px;">
        ${campoTexto("ica_municipio","Municipio","Donde está registrada la actividad","Ej: Bogotá D.C.")}
        ${campo("ica_tarifa_mil","Tarifa de la actividad (‰ por mil)",{step:"0.001",help:"Ej: 11,04 ‰ comercio al por mayor · 9,66 ‰ servicios (Bogotá, Acuerdo 65 de 2002)."})}
      </div>
    </div>
  `;

  const seccionAutorretencion = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 4px;font-size:14px;font-weight:700;color:${C.text};">🔄 Autorretención especial de renta</h3>
      <div style="font-size:10.5px;color:${C.muted};margin-bottom:12px;">
        La practica la <strong>propia empresa</strong> sobre cada venta —no la retiene el cliente— cuando está
        exonerada de aportes parafiscales (Art. 114-1 E.T.). Está reglamentada por el
        <strong>Decreto 2201 de 2016</strong> (hoy DUR 1625/2016, arts. 1.2.6.6 a 1.2.6.10) y
        <strong>no reemplaza</strong> la retención que le practican los clientes: se suma a ella.
        La tarifa depende del CIIU de la actividad principal: 0,40 % / 0,80 % / 1,60 %.
        ${EMPRESA.actividad_economica ? `<br/>La actividad registrada de la empresa es el CIIU <strong>${escapeHTML(EMPRESA.actividad_economica)}</strong>.` : ""}
        <br/><strong>Confírmalo con tu contador antes de activarlo:</strong> si aplica y está apagado, faltará un anticipo de renta cada mes.
      </div>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;max-width:520px;align-items:start;">
        ${toggle("autorretencion_renta_activa","Practicar autorretención en cada venta","Genera el anticipo (1365) contra lo que se consigna a la DIAN (2365) en cada factura.")}
        ${campo("autorretencion_renta_pct","Tarifa según el CIIU",{pct:true,step:"0.01",help:"0,40 % comercio e industria · 0,80 % servicios y profesionales (incluye 7310 Publicidad) · 1,60 % extractivas."})}
      </div>
    </div>
  `;

  const seccionCuentasCobro = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">🧾 Cuentas de cobro</h3>
      <div style="display:grid;grid-template-columns:1fr;gap:10px;max-width:320px;">
        ${campo("cuenta_cobro_tope","Tope mensual por persona (COP)",{step:"1000",help:"Control interno: una cuenta de cobro (o la suma del mes de una misma persona) no puede superar este valor. El sistema avisa y bloquea al generarla."})}
      </div>
    </div>
  `;

  const seccionExoneraciones = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 9px;font-size:14px;font-weight:700;color:${C.text};">⚖️ Reglas de exoneración automática</h3>
      <div style="display:grid;grid-template-columns:1fr 1fr;gap:9px;">
        ${toggle("rst_exonera_retefuente","RST exonerado de ReteFuente","Régimen Simple de Tributación no es sujeto de retención en la fuente a título de renta (Art. 911 E.T., Ley 2010 de 2019).")}
        ${toggle("rst_exonera_reteica","RST exonerado de ReteICA","El componente del impuesto de industria y comercio queda integrado al RST en la mayoría de municipios.")}
        ${toggle("autorretenedor_exonera_retefuente","Autorretenedor exonerado de ReteFuente","Si el proveedor es autorretenedor, se autorretiene él mismo — no se le practica retefuente al pagarle.")}
      </div>
    </div>
  `;

  // Perfil de la PROPIA empresa (casilla 53 del RUT). Se muestra aquí —solo
  // lectura— porque quien ajusta las reglas de retención necesita tenerlo
  // delante: no es lo mismo configurarlas siendo autorretenedor que no. Se edita
  // en Configuración, para que el dato viva en un único sitio.
  const perfil = [
    { on: EMPRESA.regimen_iva === "responsable", label: "Responsable de IVA", codigo: "48" },
    { on: EMPRESA.regimen_iva === "no_responsable", label: "No responsable de IVA", codigo: "49" },
    { on: EMPRESA.gran_contribuyente, label: "Gran contribuyente", codigo: "13" },
    { on: EMPRESA.autorretenedor, label: "Autorretenedor", codigo: "15" },
    { on: EMPRESA.regimen_simple, label: "Régimen Simple (RST)", codigo: "47" },
    { on: EMPRESA.agente_retencion_renta, label: "Agente de retención (renta)", codigo: "07" },
    { on: EMPRESA.agente_retencion_iva, label: "Agente de retención de IVA", codigo: "09" },
    { on: EMPRESA.obligado_contabilidad, label: "Obligado a llevar contabilidad", codigo: "42" },
    { on: EMPRESA.facturador_electronico, label: "Facturador electrónico", codigo: "52" }
  ].filter(r => r.on);

  const seccionPerfilEmpresa = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:18px;">
      <h3 style="margin:0 0 4px;font-size:14px;font-weight:700;color:${C.text};">🏷️ Perfil tributario de la empresa (RUT)</h3>
      <p style="margin:0 0 9px;font-size:10.5px;color:${C.muted};">
        Responsabilidades de la casilla 53 del RUT. Describen a <strong>esta</strong> empresa, no a sus terceros — tenlas presentes al ajustar las reglas de abajo.
        Se editan en <span data-action="ir-configuracion" style="color:${C.accent};font-weight:700;cursor:pointer;text-decoration:underline;">Configuración</span>, cotejándolas con la casilla 53 del RUT.
      </p>
      ${perfil.length === 0
        ? `<div style="font-size:11.5px;color:${C.muted};">Sin responsabilidades registradas todavía.</div>`
        : `<div style="display:flex;gap:6px;flex-wrap:wrap;">${perfil.map(r => `
            <span style="background:${C.accent}15;color:${C.accent};padding:3px 9px;border-radius:6px;font-size:10.5px;font-weight:600;">
              ${escapeHTML(r.label)} <span style="opacity:.65;">· ${r.codigo}</span>
            </span>`).join("")}</div>`}
    </div>
  `;

  const restaurar = `
    <button onclick="if(confirm('¿Restaurar los Parámetros Fiscales a los valores por defecto?')){saveParametrosFiscales(${escapeHTML(JSON.stringify(DEFAULT_PARAMETROS_FISCALES))});render();}"
      style="${btnStyle(null,"secondary")}">↺ Restaurar valores por defecto</button>
  `;

  // ─── Cierre contable ──────────────────────────────────────────────────
  const seccionCierreContable = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 4px;font-size:12px;color:${C.text};">🔒 Cierre contable</h3>
      <p style="margin:0 0 9px;font-size:11.5px;color:${C.muted};">
        Se cierra solo: <strong>cada mes queda cerrado el día que termina</strong>, sea domingo o festivo.
        Ninguna factura, nota crédito, causación o asiento con fecha dentro de un mes ya cerrado puede
        crearse ni editarse; el mes en curso está disponible hasta su último día. No hay nada que configurar
        —antes era una fecha a mano, y bastaba escribir un día que aún no había llegado para dejar a todos
        sin poder registrar nada.
      </p>
      <div style="display:flex;gap:9px;align-items:center;flex-wrap:wrap;">
        <span style="font-size:11.5px;color:#0f172a;font-weight:700;background:#f1f5f9;padding:6px 12px;border-radius:6px;">
          🔒 Cerrado hasta: ${fmtDate(fechaCierreVigente())}
        </span>
        <span style="font-size:11.5px;color:${C.muted};">
          Abierto desde el ${fmtDate(addDias(fechaCierreVigente(), 1))} en adelante.
        </span>
      </div>
    </div>
  `;

  // ─── Consecutivos de documentos ──────────────────────────────────────
  if (state._consecutivosCache === undefined) {
    state._consecutivosCache = null; // null = cargando
    cargarConsecutivosActuales().then(mapa => { state._consecutivosCache = mapa; render(); });
  }
  const consecutivosCache = state._consecutivosCache;
  const seccionConsecutivos = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 4px;font-size:12px;color:${C.text};">🔢 Consecutivos de documentos</h3>
      <p style="margin:0 0 9px;font-size:11.5px;color:${C.muted};">El siguiente número generado será el valor que fijes aquí + 1. Útil para continuar una numeración existente (p.ej. si vienes de otro sistema) o para arrancar en el consecutivo exigido por una resolución DIAN.</p>
      ${consecutivosCache === null ? `<div style="font-size:11.5px;color:${C.muted};">Cargando consecutivos actuales…</div>` : `
        <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;min-width:520px;">
          <thead><tr>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Tipo de documento</th>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Prefijo</th>
            <th style="text-align:right;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Último usado</th>
            <th style="text-align:right;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Fijar en</th>
            <th style="border-bottom:1px solid ${C.border};"></th>
          </tr></thead>
          <tbody>
            ${PREFIJOS_CONSECUTIVOS.map(p => {
              const actual = consecutivosCache[p.prefijo] || 0;
              return `
                <tr>
                  <td style="padding:8px;font-size:11.5px;color:${C.text};border-bottom:1px solid ${C.border};">${p.label}</td>
                  <td style="padding:8px;font-size:11.5px;color:${C.muted};border-bottom:1px solid ${C.border};">${p.prefijo}</td>
                  <td style="padding:8px;font-size:11.5px;color:${C.text};text-align:right;border-bottom:1px solid ${C.border};">${p.prefijo}-${String(actual).padStart(4,"0")}</td>
                  <td style="padding:8px;border-bottom:1px solid ${C.border};text-align:right;">
                    <input type="number" min="0" id="consecutivo-${p.prefijo}" placeholder="${actual}" style="${inputStyle}width:100px;text-align:right;"/>
                  </td>
                  <td style="padding:8px;border-bottom:1px solid ${C.border};text-align:right;">
                    <button data-action="guardar-consecutivo" data-prefijo="${p.prefijo}" style="${btnStyle(null,"secondary",true)}">Guardar</button>
                  </td>
                </tr>
              `;
            }).join("")}
          </tbody>
        </table>
        </div>
      `}
    </div>
  `;

  // ─── Resolución DIAN de facturación electrónica ──────────────────────
  const resoluciones = state.data.resoluciones_dian || [];
  const seccionResolucionDian = `
    <div style="background:white;border:1px solid ${C.border};border-radius:6px;padding:11px;margin-bottom:10px;">
      <h3 style="margin:0 0 4px;font-size:12px;color:${C.text};">🧾 Resolución DIAN de facturación electrónica</h3>
      <p style="margin:0 0 9px;font-size:11.5px;color:${C.muted};">Registra aquí la resolución vigente para recibir una alerta automática en el Centro de Alertas cuando esté por vencer.</p>
      ${resoluciones.length === 0 ? `<div style="font-size:11.5px;color:${C.muted};margin-bottom:9px;">Sin resoluciones registradas aún.</div>` : `
        <div style="overflow-x:auto;">
        <table style="width:100%;border-collapse:collapse;margin-bottom:10px;min-width:700px;">
          <thead><tr>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">N° Resolución</th>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Prefijo</th>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Rango</th>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Vigencia</th>
            <th style="text-align:left;padding:8px;font-size:10.5px;color:${C.muted};border-bottom:1px solid ${C.border};">Estado</th>
            <th style="border-bottom:1px solid ${C.border};"></th>
          </tr></thead>
          <tbody>
            ${resoluciones.map(r => {
              const dias = r.fecha_hasta ? calcularDiasRestantes(r.fecha_hasta) : null;
              const vigTxt = dias == null ? "—" : dias < 0
                ? `<span style="color:#ef4444;font-weight:700;">Vencida hace ${Math.abs(dias)}d</span>`
                : `<span style="color:${dias<=30?"#f59e0b":C.muted};font-weight:${dias<=30?700:400};">${dias}d restantes</span>`;
              return `
                <tr>
                  <td style="padding:8px;font-size:11.5px;border-bottom:1px solid ${C.border};">${escapeHTML(r.numero_resolucion||"—")}</td>
                  <td style="padding:8px;font-size:11.5px;border-bottom:1px solid ${C.border};">${escapeHTML(r.prefijo||"—")}</td>
                  <td style="padding:8px;font-size:11.5px;border-bottom:1px solid ${C.border};">${r.rango_desde??"—"} - ${r.rango_hasta??"—"}</td>
                  <td style="padding:8px;font-size:11.5px;border-bottom:1px solid ${C.border};">${fmtDate(r.fecha_desde)} → ${fmtDate(r.fecha_hasta)}<br>${vigTxt}</td>
                  <td style="padding:8px;font-size:11.5px;border-bottom:1px solid ${C.border};">${r.activa!==false?'<span style="color:#059669;font-weight:700;">Activa</span>':`<span style="color:${C.muted};">Inactiva</span>`}</td>
                  <td style="padding:8px;border-bottom:1px solid ${C.border};text-align:right;">
                    <button data-action="eliminar-resolucion-dian" data-id="${r.id}" style="${btnStyle(null,"secondary",true)}" title="Eliminar">🗑️</button>
                  </td>
                </tr>
              `;
            }).join("")}
          </tbody>
        </table>
        </div>
      `}
      <div style="border-top:1px solid ${C.border};padding-top:14px;">
        <div style="font-size:11.5px;font-weight:700;color:${C.text};margin-bottom:10px;">+ Nueva resolución</div>
        <div style="display:flex;gap:10px;flex-wrap:wrap;align-items:flex-end;">
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">N° Resolución</label><input id="res-numero" type="text" style="${inputStyle}width:160px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Fecha resolución</label><input id="res-fecha" type="date" style="${inputStyle}width:150px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Prefijo</label><input id="res-prefijo" type="text" placeholder="FE" style="${inputStyle}width:80px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Rango desde</label><input id="res-desde" type="number" min="1" style="${inputStyle}width:100px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Rango hasta</label><input id="res-hasta" type="number" min="1" style="${inputStyle}width:100px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Vigente desde</label><input id="res-vig-desde" type="date" style="${inputStyle}width:150px;"/></div>
          <div><label style="font-size:10px;color:${C.muted};display:block;margin-bottom:3px;">Vigente hasta (vencimiento)</label><input id="res-vig-hasta" type="date" style="${inputStyle}width:150px;"/></div>
          <button data-action="guardar-resolucion-dian" style="${btnStyle("#dc2626")}">+ Agregar resolución</button>
        </div>
      </div>
    </div>
  `;

  return header + aviso + seccionCierreContable + seccionConsecutivos + seccionResolucionDian + seccionPerfilEmpresa + seccionUVT + seccionRetefuente + seccionReteIVA + seccionICA + seccionAutorretencion + seccionCuentasCobro + seccionExoneraciones + restaurar;
}

import { registerActions } from "../ui/actions.js";

registerActions({
  "ir-parametros-fiscales": (d, el, e) => {{
      navigateTo("parametros-fiscales");
      return;
    }},
  "ir-configuracion": (d, el, e) => {{
      navigateTo("config");
      return;
    }},
  "guardar-consecutivo": async (d, el, e) => {{
      const prefijo = d.prefijo;
      const input = document.getElementById(`consecutivo-${prefijo}`);
      const valor = parseInt(input?.value, 10);
      if (isNaN(valor) || valor < 0) { alert("⚠️ Ingresa un número válido (0 o mayor)."); return; }
      try {
        const anterior = (state._consecutivosCache || {})[prefijo];
        await establecerNumeroDoc(prefijo, valor);
        registrarEvento("consecutivos", prefijo, "consecutivo_ajustado", { referencia: prefijo, detalle: {
          ultimo_anterior: anterior != null ? anterior : "—", ultimo_nuevo: valor,
          siguiente: `${prefijo}-${String(valor + 1).padStart(4, "0")}`
        } });
        state._consecutivosCache = await cargarConsecutivosActuales();
        alert(`✅ Consecutivo de ${prefijo} fijado en ${valor}. El siguiente número generado será ${prefijo}-${String(valor+1).padStart(4,"0")}.`);
        render();
      } catch (err) {
        alert("⚠️ " + err.message);
      }
      return;
    }},
  "guardar-resolucion-dian": (d, el, e) => {{
      const numero_resolucion = (document.getElementById("res-numero")?.value || "").trim();
      const fecha_resolucion = document.getElementById("res-fecha")?.value || null;
      const prefijo = (document.getElementById("res-prefijo")?.value || "").trim().toUpperCase();
      const rango_desde = parseInt(document.getElementById("res-desde")?.value, 10);
      const rango_hasta = parseInt(document.getElementById("res-hasta")?.value, 10);
      const fecha_desde = document.getElementById("res-vig-desde")?.value || null;
      const fecha_hasta = document.getElementById("res-vig-hasta")?.value || null;
      if (!numero_resolucion) { alert("⚠️ Ingresa el número de resolución"); return; }
      if (!fecha_hasta) { alert("⚠️ Ingresa la fecha de vencimiento (vigencia) de la resolución"); return; }
      const nueva = {
        id: genId(), numero_resolucion, fecha_resolucion, prefijo,
        rango_desde: isNaN(rango_desde) ? null : rango_desde,
        rango_hasta: isNaN(rango_hasta) ? null : rango_hasta,
        fecha_desde, fecha_hasta, activa: true
      };
      saveData("resoluciones_dian", [...(state.data.resoluciones_dian||[]), nueva]);
      render();
      return;
    }},
  "eliminar-resolucion-dian": (d, el, e) => {{
      if (!confirm("¿Eliminar esta resolución?")) return;
      deleteData("resoluciones_dian", d.id);
      render();
      return;
    }},
});
